import { kebabCase } from 'lodash';

import { useAvgMonthlyPaymentField } from '@makemydeal/dr-dash-components';

import { ReadOnlyValueRow } from '../../ReadOnlyValueRow';

export const FlexBuyAvgPaymentRow = () => {
    const { label, value } = useAvgMonthlyPaymentField();

    return <ReadOnlyValueRow rowKey="flexBuyAvgPayment" label={label} value={value} labelTestId={kebabCase(label)} />;
};
